export enum CardObjectTypeOption {
  LEAD_DRAFT = '97af3c2c-d7ea-11eb-b8bc-0242ac130003',
  ACCOUNT = 'd7274934-df29-4fef-b469-e23ca149b842',
  CONTACT = 'bc16dd7b-3ec0-440c-95b6-b3dc5f66e08f',
  OPPORTUNITY = '37f677ae-9c14-455b-b0b4-4c29aeadc467',
  ACTIVITY = 'cd936337-b1c4-4f77-bee0-506cae3222e3',
  OFFER = 'e0b8212b-cb1a-4156-972a-77da2961c33b',
}
